module.exports = __webpack_public_path__ + "static/assets/40a5cd39d5fc4fbeefc66be68e9ee09f.png";